import { render } from "./CasinoPlay.vue?vue&type=template&id=394dd2e2&scoped=true"
import script from "./CasinoPlay.vue?vue&type=script&lang=js"
export * from "./CasinoPlay.vue?vue&type=script&lang=js"

import "./CasinoPlay.vue?vue&type=style&index=0&id=394dd2e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394dd2e2"]])

export default __exports__